import { Routes } from '@angular/router';
import { environment } from '@environments/environment';
import { accountRoutes } from '@infodocs/account/account-routes';
import { companyRoutes } from '@infodocs/company/company-routes';
import { portfolioRoutes } from '@infodocs/portfolio/portfolio-routes';
import { publicRoutes } from '@infodocs/public/public-routes';
import {
	PrivatePagesWrapperComponent
} from '@infodocs/shared/components/private-pages-wrapper/private-pages-wrapper.component';
import { AuthGuard } from '@infodocs/shared/guards/auth.guard';
import { SupportUserGuard } from '@infodocs/shared/guards/support-user.guard';
import { signatureRoutes } from '@infodocs/signature/signature-routes';
import { transactionRoutes } from '@infodocs/transaction/transaction-routes';
import { trustRoutes } from '@infodocs/trust/trust-routes';
import { userRoutes } from '@infodocs/user/user-routes';
import { xeroAuthRoutes } from '@infodocs/xero-auth/xero-auth-routes';

export const appRoutes: Routes = [
	{
		path: 'account',
		children: accountRoutes
	},
	{
		path: 'user',
		children: userRoutes
	},
	{
		path: 'portfolio',
		component: PrivatePagesWrapperComponent,
		children: portfolioRoutes
	},
	...(environment.environmentName !== 'production'
		? [
				{
					path: 'demo/modals',
					canActivate: [AuthGuard, SupportUserGuard],
					loadComponent: () =>
						import('@infodocs/public/pages/modal-demo-page/modal-demo-page.component').then(
							(m) => m.ModalDemoPageComponent
						),
				},
			]
		: []),

	{
		path: 'company',
		children: companyRoutes
	},
	...(environment.trustsEnabled ? [{
		path: 'trust',
		children: trustRoutes
	}] : []),
	{
		path: 'transaction',
		children: transactionRoutes
	},
	{
		path: 'signature',
		children: signatureRoutes
	},

	// ID24-3894 temporary Xero auth POC routes
	...xeroAuthRoutes,

	// fallback route
	{
		path: '',
		children: publicRoutes
	},
];
